import React, { useContext, useEffect } from 'react'
import deleteIcon from '../../images/png/deleteIcon.png'
import editIcon from '../../images/png/editIcon.png'

import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { PostsContext } from '../../context/posts'

const Image = styled.img`
    width: 28px;
    height:26px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 21px;
        height: 21px;
        margin-left: 0.8rem;
        
    }

`
const ImageProduct = styled.img`
    width: 66px;
    height:66px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 21px;
        height: 21px;
        margin-left: 0.8rem;
        
    }

`


const TableListFacebook = ({ data, structure }) => {
    const {facebookPosts,getFacebookPosts,deleteFacebookPost} = useContext(PostsContext)

    useEffect(() => {
        getFacebookPosts()
    },[])

    return (
        <div className='container_startpn_table_categorys'>
            <table>

                <thead className='container_startpn_table_categorys'>
                    <tr>
                        {structure?.map((item, index) => {
                            return (
                                <td key={index}>{item.name}</td>

                            )
                        })}
                    </tr>
                </thead>


                <tbody className=''>
                    {String(facebookPosts).length == 0

                        ?
                        <tr>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>

                        </tr>
                        :

                        facebookPosts?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td >#{item.id}</td>
                                    <td >{item.name}</td>
                                    <td data-toggle="modal" data-target=""><ImageProduct src={item.image} /></td>
                                    <td data-toggle="modal" data-target="" onClick={() => deleteFacebookPost(item.facebook_id)} > <Image src={deleteIcon} /></td>

                                </tr>
                            )
                        })}



                </tbody>
            </table>
        </div>
    )
}

export default TableListFacebook